import type { ICompany, IResponseWithLoading } from "App/Modules/Models";
import type { ICompaniesRepository } from "App/Modules/Repositories";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class CompanyDetailsReactWrapperController {
    public static $inject: string[] = ["mmCompaniesRepository"];

    public companyId: string;

    // Set by transition
    public company: IResponseWithLoading<ICompany>;
    public errorResponse: IResponseWithLoading<void>;

    constructor(private readonly companiesRepository: ICompaniesRepository) {}

    public $onInit() {
        extendWithLoadingAndFail(this.companiesRepository.getCompany(this.companyId), 0).subscribe(
            (response) => {
                if (!response.hasError && response.data) {
                    this.company = response;
                }
            },
            (error) => {
                this.errorResponse = error;
            },
        );
    }
}
